import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortCurrency'
})
export class ShortCurrencyPipe implements PipeTransform {
  transform(value: number): string {
    if (value === null) return '';
    const abs = Math.abs(value);
    let result: string;

    if (abs >= 1_000_000_000)
      result = `${(Math.floor((value * 10) / 1_000_000_000) / 10).toFixed(0)}B`;
    else if (abs >= 1_000_000)
      result = `${(Math.floor((value * 10) / 1_000_000) / 10).toFixed(0)}M`;
    else if (abs >= 1_000)
      result = `${(Math.floor((value * 10) / 1_000) / 10).toFixed(0)}K`;
    else result = value.toFixed(2);

    result = result.replace(/\.0$/, '');
    return `$${result}`;
  }
}
